import React from 'react';
import "./ModalLayout.scss";

import Modal from "react-bootstrap/Modal";
import FullscreenSpinner from '../Spinner/FullscreenSpinner';

/**
 * 
 * @param {Object} action - React state [action, setAction] - This builds the modal and contains the following elements:
 * @param {string} action.action - The name of the action you are performing (in kebab-case)
 * @param {string} action.title - Title of the modal and appears in the modals header along with a close icon
 * @param {string} action.size - How big the modal should be. There are three sizes: "sm", "md" and "lg". By default, the size is set to "md" in case there is no size set.
 * @param {*} action.component - This is the content of the modal body and contains a React component.
 * @param {* | string} [action.footer] - This is de footer of the modal and can contain a React component/fragment or text. 
 * @param {Function} closeModal - function to close the modal: `const closeModal = () => { setShow(false); };`
 * @param {Boolean} show - React state [show, setShow] - Shows or hides the modal
 * @param {*} showSpinner - React state [showSpinner, setShowSpinner] - Shows the FullScreenSpinner in the modal.
 * @param {string} spinnerText - React state [spinnerText, setSpinnerText] - This is the text that is displayed within the spinner.
 */
function ModalLayout({closeModal, action, show, showSpinner, spinnerText}) {
    let size = "md"; // available sizes: sm md lg
    if(action.size) size = action.size;
    const forced = !!action.forced;

return (
    <>
        <Modal show={show} onHide={forced ? undefined : closeModal} backdrop="static" animation={true} size={size}>
            {showSpinner ? <FullscreenSpinner displayText={spinnerText} /> : ""}
            <Modal.Header>
                <Modal.Title>{action.title}</Modal.Title>
                {!forced && <span className="btn-close" onClick={closeModal}></span>}
            </Modal.Header>

            <Modal.Body>
                {action.component}
            </Modal.Body>

            {action.footer && (
                <Modal.Footer>
                    {action.footer}
                </Modal.Footer>
            )}
        </Modal>
    </>
  )
}

export default ModalLayout;
